import { FtfcFilterModule } from '../setupFiltersModules/ftfc/FtfcFilterModule';
import { PriceIntersectsFirstCandleModule } from '../setupFiltersModules/priceIntersectsFirstCandle/PriceIntersectsFirstCandleModule';
import { TimeOfDayModule } from '../setupFiltersModules/timeOfDay/TimeOfDayModule';

export const setupFiltersMap = {
  FTFC: FtfcFilterModule,
  TIME_OF_DAY: TimeOfDayModule,
  PRICE_INTERSECTS_FIRST_CANDLE: PriceIntersectsFirstCandleModule,
};
